import * as React from "react";

const Icon = ({ color }) => (

  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21.246}
    height={21.241}
    color={color}
  >
    <g
      data-name="Group 572"
      transform="translate(-745.999 -387.001)"
      fill={color}
    >
      <path
        data-name="icon"
        d="M767.243 397.769a10.623 10.623 0 10-17.556 7.9 10.623 10.623 0 0013.654.17 10.566 10.566 0 003.902-8.07zm-19.828-.253a9.206 9.206 0 1116.217 6.076v-.212a4.249 4.249 0 00-4.178-4.334h-5.666a4.249 4.249 0 00-4.32 4.17v.212a9.157 9.157 0 01-2.053-5.912z"
      />
      <circle
        data-name="Ellipse 23"
        cx={3.541}
        cy={3.541}
        r={3.541}
        transform="rotate(-89.29 577.812 -182.44)"
      />
    </g>
  </svg>
);


export default Icon;
